'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-13d783d6.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgArrow = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 7 11", height: "100%", width: "100%", fill: "currentColor" }, svgProps),
            React__default['default'].createElement("g", null,
                React__default['default'].createElement("path", { d: "M5.363 5.509l-.326.017-.536.018.517-.007-.254.007-.012-.012.191-.014-.195.009L1.97 2.745l.072-.078-.084.067-.047-.047.24-.259-.277.221-1.28-1.282.05-.054-.058.046-.05-.05.024-.042-.147.142-.045.046.713-.711.25-.219.107-.114.068.069-.394.418.355-.291.082-.084.006.006-.134.144.155-.123 2.169 2.172-.244.264.283-.225.011.01-.067.072.078-.061 2.759 2.763-.66-.022-.095-.024-.327.011-.12-.002zM.87 10.083l-.179-.165-.277-.277.243.282-.139-.121.039-.039.111.093-.097-.107 3.115-3.12.078.072-.067-.084.047-.047.259.239-.221-.277.962-.964.099.006-.096-.009.015-.015.067-.003-.287-.001H4.45l1.422.001.441.028.225-.003-.137.137-.765-.047c.183.032.36.071.53.116l.15.017-.013.013-.252-.025.21.068-2.552 2.556-.264-.244.225.282-.011.011-.072-.066.061.077-2.238 2.241-.304-.335-.016-.054-.17-.17-.052-.065z" })))));
};

exports.default = SvgArrow;
//# sourceMappingURL=index.js.map
